import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";

import "./index.scss";

const MessagePage = () => {
  const { t } = useTranslation();
  const userName = useSelector((state) => state.userName);

  return (
    <div className="message-page">
      <div className="header_container">
        <div className="home flex-between-center">
          <div>
            <FontAwesomeIcon icon={faHome} />
            <span className="welcome-container">{`${t(
              "welcomeString.welcome"
            )}, ${userName}`}</span>
          </div>
        </div>
        <div className="header-divider" />
        <div className="container-dupont-icon">
          <div className="dupont-icon">
            <div>
              <img src={require("../assets/DuPont_Logo.png")} height="30px" />
              <div className="water-solution">
                {t("headerString.waterSolution")}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="message-content">
        <div className="message-text">{t("requestAcess.message")}</div>
      </div>
    </div>
  );
};

export default MessagePage;
